// 获取索引，秘钥截取开始，截取结束
export const getPosFromSaltIndex = saltIndex => {
  return {
    keyIndex: saltIndex >>> 8,
    keyStartIndex: (saltIndex >>> 4) & 15,
    keyEndIndex: saltIndex & 15
  }
}

// 合成saltIndex
export const getSaltIndexFromPos = (keyIndex, keyStartIndex, keyEndIndex) => {
  return (keyIndex << 8) | (keyStartIndex << 4) | keyEndIndex
}

/**
 * 生成指定范围[min,max]的随机整数
 */
export const getRandomInt = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1)) + min
}

// 秘钥截取开始，截取结束 type3
export const getType3SaltIndexPos = saltIndex => {
  return {
    keyStartIndex: (saltIndex >>> 7) & 127,
    keyEndIndex: saltIndex & 127
  }
}

// 合成saltIndex type3
export const getSaltIndexFromPosType3 = (keyStartIndex, keyEndIndex) => {
  // 生成14位二进制值：前7位为起始下标，后7位为结束下标
  // 将起始下标左移7位，然后与结束下标进行或运算
  return (keyStartIndex << 7) | keyEndIndex
}
